<template>
  <v-dialog v-model="dialog" v-if="serviceCredential != null" persistent max-width="700">
    <v-card dark>
      <v-card-title class="headline">
        View Service Credential
      </v-card-title>
    </v-card>
    <v-card>
      <v-card-text>
        <v-layout>
          <p> Copy the following three values into your Camunda process to authenticate with the service registry: </p>
        </v-layout>
        <v-layout wrap>
          <v-flex md4 offset-md1>
            <ItemTextField title="ClientId" :value="serviceCredential.ClientId" />
          </v-flex>
          <v-flex md4 offset-md1>
            <ItemTextField title="RefreshToken" :value="serviceCredential.RefreshToken" />
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <p style="margin: 0 auto; margin-top: 10px;"> {{ responseMessage }} </p>
        </v-layout>
        <!-- <v-layout>
            <h4> Usage history table </h4>
          </v-layout>
          <v-layout>
            <UsageHistoryTable />
          </v-layout> -->
      </v-card-text>
      <v-card-actions>
        <v-btn @click="setDialog(false)">{{$t('Button.Close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ItemTextField from './ItemTextField'
  import UsageHistoryTable from './UsageHistoryTable'

  export default {
    components: {
      ItemTextField,
      UsageHistoryTable,
    },
    props: {
      serviceCredential: Object,
    },
    data() {
      return {
        dialog: false,
        isRemoving: false,
        responseMessage: '',
      }
    },
    methods: {
      setDialog(value) {
        this.lastCopiedKey = null
        this.dialog = value
        this.responseMessage = ''
        this.isRemoving = false
      },
      remove() {
        if (confirm('Are you sure you want to revoke this credential? All processes using this credential must be updated.')) {
          this.isRemoving = true
          this.$store.dispatch('servicecredentials/revokeRefreshToken', this.serviceCredential)
            .then(function() {
              this.isRemoving = false
              this.setDialog(false)
            }.bind(this))
            .catch(function(error) {
              this.isremoving = false
              console.log(error)
              this.responseMessage = error.response.data.ExceptionMessage
            }.bind(this))
        }
      },
    },
  }
</script>